import React, { Component } from 'react';
import axios from 'axios';

class Weather extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      trigger: false,
      weather: {},
      error: false,
    };

    this.triggerNext = this.triggerNext.bind(this);
  }

  componentDidMount() {

    axios.get('/api/weather')
    .then((response) => {
      if(response.data && response.data.success === false) {
        this.setState({ loading: false, error: true });
      }
      if(response.data && response.data.current) {
        this.setState({ 
          loading: false, 
          weather: response.data.current
        });
      }
      // Continue
      setTimeout( () => {
        this.triggerNext();
      }, 1500);
    })
    .catch((error) => {
      // Something went wrong
      this.setState({ loading: false, error: true });
      // Continue
      setTimeout( () => {
        this.triggerNext();
      }, 1500);
    });

  }

  triggerNext() {
    this.setState({ trigger: true }, () => {
      this.props.triggerNextStep();
    });
  }

  render() {
    return(
      <div className="Weather">
        { this.state.loading ? (
          <p>Contacting weather gods...</p>
        ) : (
          <div>
            { this.state.error ? (
              <p>Error contacting the weather API <span role="img" aria-label="Skull">💀</span></p>
            ) : (
              <div className="Weather__result">
                <img src={this.state.weather.weather_icons ? this.state.weather.weather_icons[0] : 'Weather-icon'} alt="Weather icon"/>
                <div>
                  <p>Copenhagen</p>
                  <p>Observation time: {this.state.weather.observation_time}</p>
                  <p>{this.state.weather.temperature} &#8451;</p>
                  <p>{this.state.weather.weather_descriptions ? this.state.weather.weather_descriptions[0] : 'Weather description'}</p>
                </div>
              </div>
            ) }
          </div>
        ) }
      </div>
    )
  }
}

export default Weather